import styled from 'styled-components'

import PropTypes from 'prop-types'
import Tooltip from '@shared/components/Tooltip'

export const Container = styled.label`
  display: flex;
  cursor: pointer;

  .file {
    &__button,
    &__show {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      font-size: .75rem;
      font-weight: 500;
    }

    &__button {
      color: ${(props) => props.theme.heading};
    }

    &__show {
      border: 0;
      background-color: transparent;
      color: ${(props) => props.theme.primary};
      margin: 0 1rem;
      text-decoration: none;
    }

    &__input {
      display: none;
    }
  }
`

Container.displayName = 'File'

Container.propTypes = {
  horizontal: PropTypes.bool
}

export const Error = styled(Tooltip)`
  margin-left: auto;
  padding: 0rem 1rem;

  span {
    background: #c53030;
    color: ${(props) => props.theme.white};
    &::before {
      border-color: #c53030 transparent;
    }
  }
`
Error.displayName = 'FileError'
